import { render, staticRenderFns } from "./UmbrellaForm.vue?vue&type=template&id=0bfd715a&scoped=true&"
import script from "./UmbrellaForm.vue?vue&type=script&lang=ts&"
export * from "./UmbrellaForm.vue?vue&type=script&lang=ts&"
import style0 from "./UmbrellaForm.vue?vue&type=style&index=0&id=0bfd715a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfd715a",
  null
  
)

export default component.exports